<template>
  <p>请使用电脑访问</p>

</template>

<script>
export default {
  name: "MobilePage"
}
</script>

<style scoped>

</style>